import { useCurrencyAmountFormatter } from '@routable/shared';
import { useSelector } from 'react-redux';
import { CurrencyCode } from 'constants/currency';
import { SWIFT_CHARGE_OPTIONS_BILLING_CODES } from 'constants/paymentMethods';
import { billingDataByCodeSelector } from 'selectors/billingSelectors';
const useSwiftChargeOptionsCost = ({ precision = 0 } = {}) => {
    const { formatCurrencyAmount } = useCurrencyAmountFormatter();
    const billingDataByCode = useSelector(billingDataByCodeSelector);
    const our = formatCurrencyAmount({
        amount: billingDataByCode[SWIFT_CHARGE_OPTIONS_BILLING_CODES.our]?.rate,
        currency: CurrencyCode.USD,
        precision,
    });
    const sha = formatCurrencyAmount({
        amount: billingDataByCode[SWIFT_CHARGE_OPTIONS_BILLING_CODES.sha]?.rate,
        currency: CurrencyCode.USD,
        precision,
    });
    return { our, sha };
};
export default useSwiftChargeOptionsCost;
